import React from 'react';
import { Button, Flex, Img, Text } from '@chakra-ui/react';
import { FiArrowUpRight } from 'react-icons/fi';

interface WinnerCardPropsI {
  title: string;
  desc: string;
  type?: string;
  link?: string;
  year?: string;
  imgSrc?: string;
}

const WinnerCard: React.FC<WinnerCardPropsI> = ({
  title,
  desc,
  type,
  link,
  year,
  imgSrc,
}) => (
  <Flex
    maxW={type === 'booklet' ? '769px' : '535px'}
    w={
      type === 'booklet'
        ? { xs: '100%', sm: '95%', lg: '769px' }
        : { xs: '100%', sm: '95%', lg: '535px' }
    }
    p={{ xs: '16px', sm: '22px', md: '26px', lg: '34px' }}
    border="1px solid #EDEDED"
    borderRadius="10px"
    boxShadow="lg"
    gap="41px"
    bg="white"
    flexShrink="0"
    flexDir={type === 'booklet' ? { xs: 'column', md: 'row' } : 'row'}
    rowGap="10px"
  >
    <Img
      src={
        type === 'award'
          ? '/png/star_award.png'
          : year === '2022'
          ? imgSrc
          : undefined
      }
      alt={type === 'award' ? 'Winner icon' : title}
      objectFit="contain"
      w={type !== 'booklet' ? '68px' : imgSrc ? '100%' : '0px'}
      h={type !== 'booklet' ? '68px' : imgSrc ? '100%' : '0px'}
    />

    <Flex flexDir="column">
      <Text
        variant="infoText"
        fontSize={type === 'booklet' ? '30px' : '20px'}
        pb="9px"
      >
        {desc} {year}
      </Text>
      <Text
        variant="infoText"
        fontSize="16px"
        color={type === 'booklet' ? 'rgba(61, 61, 95, 0.78)' : '#05856f'}
        pb="15px"
        fontWeight={type === 'booklet' ? '600' : '800'}
        letterSpacing={type === 'booklet' ? '0.02em' : 'inherit'}
      >
        {title}
      </Text>
      {type === 'booklet' && (
        <Button
          as="a"
          rel="noreferrer"
          href={link}
          borderRadius="0px"
          bgColor="primary.500"
          color="white"
          fontSize="14px"
          fontWeight="700"
          lineHeight="21px"
          letterSpacing="0.02em"
          w="162px"
          h="47px"
          rightIcon={<FiArrowUpRight color="white" size="15px" />}
          target="_blank"
          _hover={{ bgColor: 'primary.600' }}
          _active={{ bgColor: 'primary.700' }}
        >
          View Booklet
        </Button>
      )}
    </Flex>
  </Flex>
);

export default WinnerCard;
